import * as Sentry from '@sentry/vue'

export function setupSentry(app, {router} = {}) {
  const dsn = process.env.VUE_APP_SENTRY_DSN
  if (!dsn) return null

  const integrations = []

  if (router) {
    integrations.push(
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
    )
  }

  return Sentry.init({
    app,
    dsn,
    integrations,
  })
}
